import SetUpPaces from "@/components/Onboarding/SetUpPaces/SetUpPaces";

function SetUpPacesPage() {
  return <SetUpPaces />;
}

export default SetUpPacesPage;
